import initializeApplicationHelper from '../Entries/helperEntry';
import initializeNavigation from "../Entries/navigationEntry";
import initializeBurgerMenu from "../Entries/burgerMenuEntry";
import initializePRGLink from "../Entries/prgLinkEntry";
import initializeFlightSearchMask from "Entries/flightSearchMaskEntry";
import initializeTippy from "Entries/tippyEntry";
import initializeLanguageSwitcherLinks from "../Entries/languageSwitcherEntry";
document.addEventListener('DOMContentLoaded', function () {
    document.body.className += ' loaded';
    initializeLanguageSwitcherLinks();
    initializeBurgerMenu();
    initializeNavigation();
    initializePRGLink();
    initializeFlightSearchMask();
    initializeTippy();
});
window.addEventListener('load', function () {
    initializeApplicationHelper();
});
if ((typeof (document.getElementById('control-arrow')) != 'undefined' && document.getElementById('control-arrow') != null) && (typeof (document.getElementById('headline')) != 'undefined' && document.getElementById('headline') != null)) {
    document.getElementById('control-arrow').addEventListener("click", function () {
        window.scrollTo({
            top: document.getElementById('headline').getBoundingClientRect().top - 100,
            behavior: 'smooth'
        });
    });
}
window.sessionStorage.removeItem('destination-list-sorting');
window.sessionStorage.removeItem('hotel-list-sorting');
